module.exports = "/fonts/ARIAL.woff?a78830e85c09c2719966c48bf015e3e1";